import { StatusViewModel, TemplateIdProjectIdViewModel, TemplateProjectCustomReportSourceViewModel, WalkAndPunchApiClient } from 'src/proxy/api/walkandpunch-api.proxy';
import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';

@Injectable()
export class SourcesStoreService {
  _sources$ = new BehaviorSubject<TemplateProjectCustomReportSourceViewModel[]>(null);

  constructor(private reportsService: WalkAndPunchApiClient) {}

  loadReportSources() {
    return this.reportsService.v1ReportGetAvailableCustomReportSourcesPOST([]);
  }

  loadSourcesFromProjectTemplate(projectTemplates: any[]) {
    return this.reportsService.v1ReportGetAvailableCustomReportSourcesPOST(
      projectTemplates.map((pt) => TemplateIdProjectIdViewModel.fromJS({ projectId: Number(pt.id.split('$')[0]), templateId: Number(pt.id.split('$')[1]) }))
    );
  }

  get sources() {
    return this._sources$.value;
  }

  set sources(data: StatusViewModel[]) {
    this._sources$.next(data);
  }

  get sources$() {
    return this._sources$;
  }
}
